
<template>
  <div v-if="callInfoId">
    <my-button v-if="!hideButton" @click="showComments">Комментарии</my-button>
    <el-dialog
        :visible.sync="localVisibleComments"
        width="85%"
        title="История изменений"
    >
      <div >
        <el-input type="textarea" placeholder="Введите новый комментарий" v-model="newComment" style="margin-bottom: 1rem;"/>
        <my-button @click="saveCallInfoComment" style="margin-right: 1rem;">Сохранить</my-button>
        <my-button @click="newComment = null">Очистить</my-button>
      </div>
      <div v-if="!comments.length">Комментарии отсутствуют</div>
      <div v-else style="margin-top: 1rem;" v-loading="loading">
        <div v-for="comment in comments">{{comment.who_created_name + ' - ' + comment.created_at + ': ' + comment.text}}</div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import MyButton from "../UI/MyButton.vue";

export default {
  name: "call-info-comments",
  components: {MyButton},
  props: {
    callInfoId: {},
    multiple: false,
    hideButton: false,
    visibleComments: false,
    categoryId: {},
  },
  data() {
    return {
      localVisibleComments: this.visibleComments,
      comments: [],
      newComment: null,
      loading: false,
    }
  },
  mounted() {
    if(this.callInfoId) {
      this.getComments()
    }
  },
  watch: {
    visibleComments(newVal) {
      this.localVisibleComments = newVal
      if(this.localVisibleComments) {
        this.getComments()
      }

    },
    localVisibleComments(newVal) {
      if (!newVal) {
        this.$emit('update:visibleComments', newVal)
      }
    }
  },
  computed: {
    // comments() {
    //   return this.comments
    // }
  },
  methods: {
    getComments() {
      this.$api.comments.getCallInfoComments( {
        call_info_id: this.callInfoId
      })
          .then(data => {
            this.comments = data
            this.loading = false;
          })
    },
    saveCallInfoComment() {
      this.loading = true;
      this.$api.comments.saveCallInfoComment( {
        comment: this.newComment,
        call_info_id: this.callInfoId,
        category_id: this.categoryId
      })
          .then(data => {
            this.comments = data
            this.loading = false;
            this.newComment = null
          })
    },
    showComments() {
      this.loading = true;
      this.getComments()
      this.localVisibleComments = true;
    }
  }
}
</script>



<style scoped lang="scss">

</style>